import { AccountManager, Bus, isEmptyCollection, SettingsManager, actions } from '@atlas/core';

import history from 'components/MainRouter/history';

const UI_BROADCAST_EVENTS = [
  'ui:betslip_toggle',
  'ui:content_size_resolve',
  'ui:goto',
  'ui:language_change',
  'ui:betslip_open',
  'ui:currency_change',
  'ui:theme_change',
  'ui:footer_iframe',
  'ui:logout',
];

window.addEventListener('message', event => {
  // Should check the domain first
  // event.origin

  if (isEmptyCollection(event.data)) {
    return;
  }

  const { action, payload } = event.data;

  if (UI_BROADCAST_EVENTS.includes(action)) {
    Bus.emit(action, payload);
  }
});

// Fixed iframe header height
const HEADER_HEIGHT = 52;

Bus.on('ui:content_size_resolve', () => {
  const layout = document.querySelector('.layout-to-scroll');

  if (layout instanceof window.HTMLElement) {
    // Full height
    const height = layout.scrollHeight + HEADER_HEIGHT;

    Bus.emit('ui:content_size', { height });
  }
});

Bus.on('ui:logout', () => {
  Bus.send({
    event: Bus.events.auth.logout,
    data: {
      withoutRedirect: true,
    },
  });
});

Bus.on('ui:goto', options => {
  history.push(options);
});

Bus.on('ui:language_change', lang => {
  SettingsManager.updateSettings({ lang });
});

Bus.on('ui:currency_change', currency => {
  AccountManager.manuallySetCurrency = currency;

  Bus.invoke({
    type: actions.ACCOUNT_UPDATE,
    payload: { currency },
  });
});

Bus.on('bet:placedSuccess', data => {
  Bus.emit(`betslip:main:${Bus.events.bet.snapshot}`, {
    betItems: [],
    source: 'iframe-application',
  });
});

Bus.on('ui:theme_change', theme => {
  SettingsManager.updateSettings({ theme });
});

Bus.on('ui:footer_iframe', footerIframe => {
  SettingsManager.updateSettings({
    footerHeight: footerIframe.footerHeight,
    footerUrl: footerIframe.footerUrl,
  });
});

Bus.emit('ui:device', 'mobile');
